"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";

const items = [
    { href: "/", label: "Dashboard" },
    { href: "/products", label: "Products" },
    { href: "/inventory", label: "Inventory" },
    { href: "/orders", label: "Orders" },
    { href: "/customers", label: "Customers" },
    { href: "/suppliers", label: "Suppliers" },
];

export default function Sidebar() {
    const pathname = usePathname();

    return (
        <aside className="w-full border-b border-rose-100 bg-white md:min-h-screen md:w-64 md:border-b-0 md:border-r">
            <div className="px-6 py-5">
                <div>
                    <p className="text-xs font-medium uppercase tracking-[0.24em] text-brand-500">Bangkok Dress</p>
                    <h2 className="mt-1 text-xl font-bold text-gray-900">Inventory</h2>
                </div>
            </div>
            <nav className="px-4 pb-4">
                <div className="flex gap-2 overflow-x-auto md:block">
                    {items.map((item) => {
                        const active = pathname === item.href;
                        return (
                            <Link
                                key={item.href}
                                href={item.href}
                                className={cn(
                                    "mb-2 inline-flex rounded-xl px-4 py-2 text-sm font-medium transition md:flex",
                                    active ? "bg-brand-50 text-brand-700" : "text-gray-600 hover:bg-rose-50"
                                )}
                            >
                                {item.label}
                            </Link>
                        );
                    })}
                </div>
            </nav>
        </aside>
    );
}